import { ICON_BY_NAME } from 'ui/components/Icons/Icon';
import { Routes } from '../../types';
import { AuthContext } from 'providers';
import { useContext } from 'react';
import Gleap from 'gleap';
interface mobileSideNavLinksProps {
  isRestricted: boolean;
  pathname: string;
  query: any;
}
export const mobileSideNavLinks = ({
  isRestricted = false,
  pathname,
  query
}: mobileSideNavLinksProps) => {
  const {
    logout
  } = useContext(AuthContext);
  const links = [{
    label: 'My Profile',
    href: Routes.Profile,
    isActive: pathname == Routes.Profile,
    isExternal: false,
    hasPermission: true,
    icon: <ICON_BY_NAME.profile width="15px" height="15px" />
  }, {
    label: 'My Purchases',
    isActive: pathname === Routes.RewardsActivity && query?.filter == 'reward_purchases',
    hasPermission: !isRestricted,
    href: Routes.RewardsPurchases,
    icon: <ICON_BY_NAME.giftone width="15px" height="16px" />
  }, {
    label: 'Rewards Activity',
    isActive: pathname === Routes.RewardsActivity && query?.filter != 'reward_purchases',
    hasPermission: true,
    href: Routes.RewardsActivity,
    icon: <ICON_BY_NAME.tokenhistory width="15px" height="16px" />
  }, {
    label: 'Settings',
    isActive: false,
    icon: <ICON_BY_NAME.settingscogoutline width="15px" height="15px" />,
    renderAsButton: true,
    hasPermission: true,
    href: `/profile${Routes.Settings}`
  }, {
    label: 'Documentation',
    isActive: false,
    icon: <ICON_BY_NAME.files width="15px" height="15px" />,
    hasPermission: true,
    href: 'https://arcadesite.webflow.io/docs'
  }, {
    label: 'Get Support',
    isActive: false,
    icon: <ICON_BY_NAME.helpcircle width="15px" height="15px" />,
    hasPermission: true,
    onClick: () => {
      Gleap.open();
    }
  }, {
    label: 'Log out',
    isActive: false,
    icon: <ICON_BY_NAME.logoutwide width="15px" height="15px" />,
    hasPermission: true,
    onClick: () => {
      logout();
    }
  }].filter(item => item.hasPermission);
  return links;
};